
    if (typeof wp !== 'undefined') {
        const { createHigherOrderComponent } = wp.compose;
        const { InspectorControls } = wp.blockEditor;
        const { PanelBody } = wp.components;
        const { ToggleControl } = wp.components;
    
        wp.hooks.addFilter(
            'blocks.registerBlockType',
            'peagsus/button-block-modal-attr',
            settings => {
                // If the block isn't a `core/button` block, we return the same settings
                if (settings.name != 'core/button') {
                    return settings;
                }
    
                // Else, we extend the attributes
                settings.attributes = {
                    ...settings.attributes,
                    openInModal: {
                        type: 'boolean',
                        default: '',
                    },
                };
    
                return settings;
            }
        );
    
        const withInspectorControls = createHigherOrderComponent((BlockEdit) => {
            return (props) => {
                const { name } = props;
    
                // If the block isn't a `core/button` block, we return an unmutated component
                if (name == 'core/button') {
                    return <PegasusExtendedButtonBlock BlockEdit={BlockEdit} {...props} />;
                }
    
                // Else, we extend the component with controls to manipulate the new attribute.
                return <BlockEdit {...props} />;
            };
        }, 'withInspectorControl');
    
        const PegasusExtendedButtonBlock = (props) => {
            const { BlockEdit, setAttributes, attributes } = props;
            const { openInModal, id } = attributes;
    
            return (
                <>
                    <BlockEdit {...props} />
                    <InspectorControls>
                        <PanelBody>
                            <ToggleControl
                                label="Open In Modal"
                                checked={openInModal}
                                onChange={() => setAttributes({ openInModal: !openInModal })}
                            />
                        </PanelBody>
                    </InspectorControls>
                </>
            )
        }
    
        wp.hooks.addFilter(
            'editor.BlockEdit',
            'peagsus/button-block-modal',
            withInspectorControls
        );
    
        wp.hooks.addFilter(
            'blocks.getSaveContent.extraProps',
            'pegasus/save-button-block-modal-attr',
            (props, blockType, attributes) => {
                const { openInModal = false } = attributes;
                const { smoothScroll = false } = attributes;
    
                if (blockType.name != 'core/button') {
                    return props;
                }
    
                props.openInModal = openInModal;
                props.smoothScroll = smoothScroll;
    
                return props;
            }
        );

        
    }
